import { Controller } from "stimulus";
export default class extends Controller {

  connect() {
    const event = new CustomEvent("widget-connected", { bubbles: true, cancelable: true })
    this.element.dispatchEvent(event);
  }
}
